var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttactpdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8728 11.5959L12.4349 20.7926C10.6212 22.56 7.68316 22.56 5.86945 20.7926C4.05575 19.0252 4.05575 16.1623 5.86945 14.3949L16.128 4.39844C16.6721 3.86819 17.4101 3.5703 18.1797 3.5703C18.9492 3.5703 19.6872 3.86819 20.2314 4.39844C20.7755 4.92868 21.0812 5.64785 21.0812 6.39773C21.0812 7.14761 20.7755 7.86677 20.2314 8.39702L11.6142 16.794C11.1629 17.2339 10.4242 17.2339 9.97286 16.794C9.52149 16.3542 9.52149 15.6344 9.97287 15.1946L17.7693 7.5973L16.5383 6.39773L8.74184 13.995C8.1977 14.5253 7.892 15.2444 7.892 15.9943C7.892 16.7442 8.1977 17.4634 8.74184 17.9936C9.28599 18.5239 10.024 18.8217 10.7935 18.8217C11.5631 18.8217 12.3011 18.5239 12.8453 17.9936L21.4624 9.59659C23.2761 7.82922 23.2761 4.96624 21.4624 3.19886C19.6487 1.43149 16.7107 1.43149 14.897 3.19886L4.63843 13.1953C2.14356 15.6264 2.14356 19.5611 4.63843 21.9922C7.1333 24.4233 11.1711 24.4233 13.6659 21.9922L23.1038 12.7955L21.8728 11.5959Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttactpdf);
export default __webpack_public_path__ + "static/media/attactpdf.6cd0f0886ab23b6426bf1226e9cf0719.svg";
export { ForwardRef as ReactComponent };